import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useAccumulatorOverrideScheduleCriteria from "./hooks/useAccumulatorOverrideScheduleCriteria";  
  
const AccumulatorOverrideScheduleCriteria = () => {  
  const accumulatorOverrideScheduleCriteriaData = useAccumulatorOverrideScheduleCriteria();  
  
  return (  
    <div class="container container-fluid grid">  
      <ButtonsSection ctaButtons={accumulatorOverrideScheduleCriteriaData.leftButtons} align="left" />
      <div className="header-section">  
        <h1>  
          {accumulatorOverrideScheduleCriteriaData.screen_title} -{" "}  
          <span className="heading-cod">  
            {accumulatorOverrideScheduleCriteriaData.screenNumber}  
          </span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={accumulatorOverrideScheduleCriteriaData.formFields}  
        dropdownValues={accumulatorOverrideScheduleCriteriaData.dropdownValues}  
        paramsData={accumulatorOverrideScheduleCriteriaData.paramsData}  
        updataParamData={accumulatorOverrideScheduleCriteriaData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={accumulatorOverrideScheduleCriteriaData.ctaButtons} />  
      <DisplayTable  
        data={accumulatorOverrideScheduleCriteriaData.data}  
        parmKey={accumulatorOverrideScheduleCriteriaData.parmKey}  
        menuOptions={accumulatorOverrideScheduleCriteriaData.menuOptions}  
        tableHeaders={accumulatorOverrideScheduleCriteriaData.columnDef}  
        setRowData={accumulatorOverrideScheduleCriteriaData.setRowData}  
        selectedPriceSchedules={accumulatorOverrideScheduleCriteriaData.selectedRows}  
        setSelectedPriceSchedules={accumulatorOverrideScheduleCriteriaData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={accumulatorOverrideScheduleCriteriaData.first}  
          rows={accumulatorOverrideScheduleCriteriaData.rows}  
          totalRecords={accumulatorOverrideScheduleCriteriaData.totalRecords}  
          currentPage={accumulatorOverrideScheduleCriteriaData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={accumulatorOverrideScheduleCriteriaData.onPageChange}  
        />  
      </div>  
      {accumulatorOverrideScheduleCriteriaData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={accumulatorOverrideScheduleCriteriaData.isConfirmationModalOpen}  
          onRequestClose={accumulatorOverrideScheduleCriteriaData.closeConfirmationModal}  
          onBack={accumulatorOverrideScheduleCriteriaData.closeConfirmationModal}  
          onSave={accumulatorOverrideScheduleCriteriaData.deleteAccumulatorOverrideScheduleCriteria}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={accumulatorOverrideScheduleCriteriaData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default AccumulatorOverrideScheduleCriteria;